module.exports = __webpack_public_path__ + "static/media/info-card-bg.f864ca91.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info-card-bg.JPG
// module id = 1255
// module chunks = 0